/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Select,
  TextArea,
  InputField,
  MyMessage,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { FOLDERS } from "../doseeData/utils/Utils";
import { usePartnerContext } from "../../context/PartnerContext";
import { getOnePartner } from "../../lib/sysNavigation/SysNavigation";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FiImage, FiBriefcase, FiAlignLeft } from "react-icons/fi";

const Edit = () => {
  const { updatePartnerState, updatePartner } = usePartnerContext();
  const partner = getOnePartner();

  const partner_id = partner.partner_id;
  const [thumbnail, setThumbnail] = useState(partner.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(partner.image_cdn_id);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(partner.name);
  const [partnerStatus, setPartnerStatus] = useState(partner.status);
  const [description, setDescription] = useState(partner.description);

  const partnerRoutes = "/partner";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOnePartnerHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      name: title,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      description: description,
      status: partnerStatus,
    };

    const { status, message } = await updatePartner(partner_id, data);
    if (status === 200) {
      updatePartnerState({ partner_id, ...data });
      cleanFields();
      responses(false, message);
    } else {
      setLoading(false);
      responses(true, message);
    }
  };

  return (
    <AddPageShell
      backRoute={partnerRoutes}
      eyebrow="Marketing • Partners"
      title="Edit Partner"
      subtitle="Update partner brand assets and short description."
      icon={<FiBriefcase className="h-5 w-5" />}
      pills={[
        { label: "Status", value: partnerStatus === 1 ? "Visible" : "Hidden" },
      ]}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOnePartnerHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Brand Assets"
        hint="JPEG or PNG. Square logos look best."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.PARTNERS}
        />
      </AddSection>

      <AddSection
        title="Partner Details"
        hint="Basic identity and visibility on the public site."
        icon={<FiBriefcase className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "partner_status",
              title: "Status",
              required: true,
              option: ["visible", "invisible"],
              preselect:
                partnerStatus !== null && partnerStatus !== undefined
                  ? [{ name: partnerStatus === 1 ? "visible" : "invisible" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setPartnerStatus(1);
                else setPartnerStatus(0);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="Aim for 120–160 characters for best readability."
        icon={<FiAlignLeft className="h-4 w-4" />}
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            required: true,
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
